<template>
  <div class="">

    <m-order-wrapper :dashboard-orders="dashboardOrders">
      <template v-slot="{orders,pagination,changePageFunction,current_page}">

        <table class="table  table-striped table-responsive-md">
          <thead>
          <tr>
            <th v-for="field in tableFields" scope="col">{{ field.value }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in orders">
            <td v-if="order_id_prop">{{ order.id }}</td>
            <td v-if="user_prop">{{ order.user.name }} {{ order.user.last_name }}</td>
            <td v-if="user_profile_prop"><img :src="userProfileImage(order.user)" alt="user-profile-image"
                                              class="user-profile-image"></td>
            <td v-if="user_cellphone_prop">
              <m-a :href="`tel:${order.user.cellphone}`">
                {{ order.user.cellphone }}
              </m-a>
            </td>
            <td v-if="user_description_prop">{{ advanceDescriptionCompiler(order.user.description) }}</td>
            <td v-if="order_paying_amount_prop">{{ formatNumber(order.paying_amount) }}</td>
            <td v-if="order_paying_status_prop">{{ order.payment_status.status_name }}</td>
            <td v-if="order_items_prop">
              <p v-for="order_item in order.items" class="d-block my-3">
                {{ order_item.product.name }} * {{ order_item.quantity }}
              </p>
            </td>
            <td v-if="order_status_prop">
              <order-status-manager1 :order="order" />
            </td>
            <td v-if="order_created_at_prop">
              <span v-html="addEnterBetweenDateAndTime(order.created_at)" dir="ltr"></span>
            </td>
            <td v-if="order_updated_at_prop">
              <span v-html="addEnterBetweenDateAndTime(order.updated_at)" dir="ltr"></span>
            </td>
            <td v-if="order_transaction_updated_at_prop">
              <span v-if="order.transaction != null"
                    v-html="addEnterBetweenDateAndTime(order.transaction.updated_at)"
                    dir="ltr"></span>
            </td>
            <td v-if="order_description_prop">{{ order.description }}</td>
            <td v-if="actions_prop">
               <span class="h5" data-toggle="tooltip" data-placement="top"
                     :title="$t('order.archive.tooltip_of_factor_button')">
                  <m-a target="_blank"
                       :href="{ name: 'Factor', params: { orderId: order.id } }">
                    <i class="bi bi-basket-fill mr-3"></i>
                  </m-a>
               </span>
              <order-delivery-code1 :order="order"/>

            </td>
          </tr>


          </tbody>
        </table>

        <div class="row pt-3 mt-3">
          <m-paginate1 :meta="pagination" :on-change-page="changePageFunction"/>
        </div>

      </template>
    </m-order-wrapper>
  </div>
</template>


<script>
import mOrderWrapper from "../Wrappers/OrderWrapper.vue";
import mPaginate1 from "../Pagination/Paginate1.vue";
import mA from '../Tags/A.vue'
import {formatNumber, dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {userAvatar} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import OrderDeliveryCode1 from "./OrderDeliveryCode/OrderDeliveryCode1.vue";
import OrderStatusManager1 from "./OrderStatusManager/OrderStatusManager1.vue";

export default {
  name: "Orders1",
  components: {mPaginate1, mOrderWrapper, mA, OrderDeliveryCode1, OrderStatusManager1},
  props: {
    order_id_prop: {
      default: true,
      type: Boolean,
    },
    user_prop: {
      default: true,
      type: Boolean,
    },
    user_profile_prop: {
      default: true,
      type: Boolean,
    },
    user_description_prop: {
      default: true,
      type: Boolean,
    },
    order_paying_amount_prop: {
      default: true,
      type: Boolean,
    },
    order_paying_status_prop: {
      default: true,
      type: Boolean,
    },
    order_status_prop: {
      default: true,
      type: Boolean,
    },
    order_created_at_prop: {
      default: true,
      type: Boolean,
    },
    order_updated_at_prop: {
      default: true,
      type: Boolean,
    },
    order_transaction_updated_at_prop: {
      default: true,
      type: Boolean,
    },
    actions_prop: {
      default: true,
      type: Boolean,
    },
    order_items_prop: {
      default: true,
      type: Boolean,
    },
    user_cellphone_prop: {
      default: true,
      type: Boolean,
    },
    order_description_prop: {
      default: true,
      type: Boolean,
    },
    dashboardOrders: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      userAvatar,
      tableFields: [
        {key: 'order_id', value: this.$t('order.table.order_id')},
        {key: 'user', value: this.$t('order.table.user')},
        {key: 'user_profile', value: this.$t('order.table.user_profile')},
        {key: 'user_cellphone', value: this.$t('order.table.user_cellphone')},
        {key: 'user_description', value: this.$t('order.table.user_description')},
        {key: 'order_paying_amount', value: this.$t('order.table.order_paying_amount')},
        {key: 'order_paying_status', value: this.$t('order.table.order_paying_status')},
        {key: 'order_items', value: this.$t('order.table.order_items')},
        {key: 'order_status', value: this.$t('order.table.order_status')},
        {key: 'order_created_at', value: this.$t('order.table.order_created_at')},
        {key: 'order_updated_at', value: this.$t('order.table.order_updated_at')},
        {key: 'order_transaction_updated_at', value: this.$t('order.table.order_transaction_updated_at')},
        {key: 'order_description', value: this.$t('order.table.order_description')},
        {key: 'actions', value: this.$t('order.table.actions')},
      ]
    }
  },
  methods: {
    formatNumber,
    dateConverter,
    addEnterBetweenDateAndTime(date) {
      date = this.dateConverter(date, '/', true);
      return date.replace(' ', '<br>')
    },
    userProfileImage(user) {
      let userImage = user.image
      if (userImage != null) {
        return userImage
      }
      return this.userAvatar
    },
    filterTableKeys(tableFields) {

      tableFields = tableFields.filter(item => { // filter table field base on prop
        // with `this` we get value of props.
        return this[`${item.key}_prop`]
      })

      return tableFields
    },
  },
  mounted() {
    this.tableFields = this.filterTableKeys(this.tableFields)
  }
}
</script>

<style scoped>
.user-profile-image {
  height: 50px;
  width: auto;
}
</style>